<template>
  <div class="bee-table-wrapper">
    <!--loading图-->
    <div class="loading-mask" v-if="loading">
      <div class="loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg>
      </div>
    </div>
    <!--设置高度，表格头固定不动-->
    <div v-if="height" id="fixHead">
      <div class="head-dh" ref="headDh">
        <div class="bee-table bee-table-fixHead" v-if="showHead" ref="beeTableFixHead">
          <tableHead
            :columns="columns"
            :data="data"
            :styleHead="styleHead"
            :showBorder="showBorder"
            :width="width"
            :widthSmll="widthSmll"
            :align="align"
            :selectAll="selectAll"
            @selectionChange="selectionChange"
            @changeAll= "changeAll"
            @sortChange="sortChange"
          ></tableHead>
        </div>
      </div>
      <div class="body-dh" ref="bodyDh">
        <div class="bee-table bee-table-body-fixHead" ref="beeTableBodyFixHead">
          <table cellspacing="0" cellpadding="0" border="0">
            <tbody class="bee-table-body" v-if="hasData" ref="body">
            <tr v-for="(column, ind) in data" :key="ind">
              <td v-for="(col, index) in columns" :key="index" :class="{'no-border':!showBorder,'thd-select':col.type === 'selection'|| col.type === 'radio'}" ref="colBodyWidth">
                <template v-if="col.type === 'selection'">
                  <input
                    type="checkbox"
                    class="input-class checkbox"
                    v-model="checked[ind]"
                    :name="data"
                    :value="column"
                    @change="changeItem"
                  />
                </template>
                <template v-else-if="col.type === 'radio'">
                  <input v-model="radio" :value="column" :name="data" class="input-radio" type="radio"/>
                </template>
                <template v-else>
                  <slot :name="col.key" :scope="{row:column, index:ind}"></slot>
                  <div v-if="!$scopedSlots[col.key]">
                    <span v-if="ellipsis" :title="column[col.key]" class="calculate">{{column[col.key]}}</span>
                    <span v-else>{{column[col.key]}}</span>
                  </div>
                </template>
              </td>
            </tr>
            </tbody>
            <tbody class="bee-table-body" v-else>
            <tr>
              <td class="bee-table-body-empty">{{noDataText}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="bee-table" v-if="showHead">
        <tableHead
          :columns="columns"
          :data="data"
          :styleHead="styleHead"
          :showBorder="showBorder"
          :width="width"
          :align="align"
          :selectAll="selectAll"
          @selectionChange="selectionChange"
          @changeAll="changeAll"
          @sortChange="sortChange"
        ></tableHead>
      </div>
      <div class="bee-table">
        <table cellspacing="0" cellpadding="0" border="0">
          <tbody class="bee-table-body" v-if="hasData" ref="body">
          <tr v-for="(column, ind) in data" :key="ind">
            <td v-for="(col, index) in columns" :key="index" :class="{'no-border':!showBorder,'thd-select':col.type === 'selection'|| col.type === 'radio'}" ref="colBodyWidth">
              <template v-if="col.type === 'selection'">
                <input
                  type="checkbox"
                  class="input-class checkbox"
                  v-model="checked[ind]"
                  :name="data"
                  :value="column"
                  @change="changeItem"
                />
              </template>
              <template v-else-if="col.type === 'radio'">
                <input v-model="radio" :value="column" :name="data" class="input-radio" type="radio"/>
              </template>
              <template v-else>
                <slot :name="col.key" :scope="{row:column, index:ind}"></slot>
                <div v-if="!$scopedSlots[col.key]">
                  <span v-if="ellipsis" :title="column[col.key]" class="calculate">{{column[col.key]}}</span>
                  <span v-else>{{column[col.key]}}</span>
                </div>
              </template>
            </td>
          </tr>
          </tbody>
          <tbody class="bee-table-body" v-else>
          <tr>
            <td class="bee-table-body-empty">{{noDataText}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import tableHead from './tableHead'
export default {
  name: 'BeeTable',
  props: {
    columns: Array, // 表头
    data: Array, // 表格数据
    emptyText: String, // 表格无显示数据时显示文案
    showHead: { // 是否显示表头
      type: Boolean,
      default: true
    },
    styleHead: { // 是否显示默认表头样式
      type: Boolean,
      default: true
    },
    showBorder: { // 是否显示边框
      type: Boolean,
      default: false
    },
    width: { // 自定义列宽
      type: [String, Number],
      default: 130
    },
    align: { // 表格文字对齐方式
      type: String,
      default: 'left'
    },
    ellipsis: { // 文字过长时是否显示省略号
      type: Boolean,
      default: false
    },
    height: { // 表头固定时自定义的高度
      type: [String, Number]
    },
    loading: { // 是否显示loading图
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      originLeft: null, // 固定表头时，表体原始left数值
      selectAll: { // 全选情况
        check: true,
        value: false
      },
      isChecked: { // 多选情况
        check: true,
        value: false
      },
      widthSmll: false, // 表头固定时，宽度是否需要-17px
      hasData: true, // 表格数据是否不为空
      noDataText: this.emptyText || '暂无数据',
      radio: [], // 单选框
      originalRadio: [], // 单选框的上次数据
      checked: [], // 数据选中情况
      selectData: [] // 存储选中数据
    }
  },
  computed: {
  },
  components: {
    tableHead
  },
  watch: {
    data(n, o) {
      // 当数据发生变化时，重置多选选中情况
      this.data.forEach((item, index) => {
        this.checked[index] = false
      })
      // 重置单选选中情况
      this.originalRadio = []
      this.radio = []
      // 数据发生变化时判断数据是否存在
      if((this.data && this.data.length === 0) || this.data === undefined) {
        this.hasData = false
      } else {
        this.hasData = true
      }
    },
    // 单选框选择是否发生变化
    'radio'(n, o) {
      this.originalRadio = o
      this.changRadio(this.radio, this.originalRadio)
    },
    // 多选框选择情况
    'isChecked.check': {
      handler(val) {
        this.checked.forEach((item, index) => {
          this.$set(this.checked, index, this.isChecked.value)
        })
        if(this.isChecked.value) {
          this.selectData = []
          let input = this.$refs.body.getElementsByClassName('checkbox')
          for(let i = 0; i < input.length; i++) {
            this.selectData.push(input[i]._value)
          }
        } else {
          this.selectData = []
        }
        this.selectionAll(this.selectData)
        this.selectionChange(this.selectData)
      }
    }
  },
  updated() {
    // 数据更新时判断是否固定头部
    if(this.height && this.height.toString().replace('px', '')) {
      if(this.$refs.body && parseFloat(this.height) < this.$refs.body.clientHeight) {
        this.fixedHead(true)
      } else {
        this.fixedHead(false)
      }
    }
  },
  methods: {
    // 表头固定后，表体表头滑动一致
    headScroll() {
      if(this.height) {
        let leftDis = this.$refs.beeTableBodyFixHead.getBoundingClientRect().left
        leftDis -= this.originLeft
        this.$refs.beeTableFixHead.style.position = 'relative'
        this.$refs.beeTableFixHead.style.left = leftDis + 'px'
        this.$refs.beeTableFixHead.style.top = '0px'
      } else {
        this.$refs.beeTableFixHead.style.position = 'relative'
        this.$refs.beeTableFixHead.style.left = '0px'
        this.$refs.beeTableFixHead.style.top = '0px'
      }
    },
    // 接收body信息，判断head是否-17
    fixedHead(val) {
      this.widthSmll = val
      if(val) {
        this.$refs.bodyDh.style.height = this.height.toString().replace('px', '') + 'px'
      } else {
        this.$refs.bodyDh.style.height = 'auto'
      }
    },
    // 多选框选中本身
    changeItem(e) {
      let flag = true
      this.checked.forEach((item, index) => {
        if(!item) {
          flag = false
        }
      })
      this.changeSelectAll(flag)
      this.selectData = []
      let input = this.$refs.body.getElementsByClassName('checkbox')
      for(let i = 0; i < input.length; i++) {
        if(input[i].checked) {
          // 未选中又选中
          this.selectData.push(input[i]._value)
          // 去重
          let ret = []
          for(let i = 0, j = this.selectData.length; i < j; i++) {
            if(ret.indexOf(this.selectData[i]) === -1) {
              ret.push(this.selectData[i])
            }
          }
          this.selectData = ret
        } else {
          // 选中后又未选中
          if(this.selectData.length) {
            this.selectData.forEach((item, ind) => {
              if(item === input[i]._value) {
                this.selectData.splice(ind, 1)
              }
            })
          }
        }
      }
      this.select(this.selectData, e.target._value)
      this.selectionChange(this.selectData)
    },
    // 是否勾选全选框
    changeSelectAll(val) {
      this.selectAll.check = !this.selectAll.check
      this.selectAll.value = val
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    select(valArray, currentVal) {
      this.$emit('select', valArray, currentVal)
    },
    // 当选择项发生变化时会触发该事件
    selectionChange(valArray) {
      this.$emit('selection-change', valArray)
    },
    // 当用户手动勾选全选 Checkbox 时触发的事件 selection-all
    selectionAll(valArray) {
      this.$emit('selection-all', valArray)
    },
    // 全选按钮
    changeAll(val) {
      this.isChecked.check = !this.isChecked.check
      this.isChecked.value = val
    },
    // 单选框
    changRadio(currentRow, oldCurrentRow) {
      this.$emit('radio-change', currentRow, oldCurrentRow)
    },
    // 排序
    sortChange(prop, sortable, sort) {
      if(sortable === true) {
        // 自动排序
        if(sort === 'ascending') {
          this.data.sort(this.compare(prop, sort))
        } else if(sort === 'descending') {
          this.data.sort(this.compare(prop, sort))
        }
      } else if(sortable === 'custom') {
        // 远程排序降序
        this.$emit('sort-change', prop, sort)
      }
    },
    // 自动排序的方法
    compare(property, sort) {
      return function(a, b) {
        let value1 = a[property]
        let value2 = b[property]
        if(sort === 'ascending') {
          return value1 > value2 ? 1 : -1
        } else if(sort === 'descending') {
          return value1 < value2 ? 1 : -1
        }
      }
    }
  },
  created() {
    // 表格数据是否存在
    if((this.data && this.data.length === 0) || this.data === undefined) {
      this.hasData = false
    } else {
      this.hasData = true
    }
    // 表格数据多选情况
    this.data.forEach((item, index) => {
      this.checked[index] = false
    })
    this.$nextTick(() => {
      // 设置固定头的属性后
      if(this.height && this.height.toString().replace('px', '')) {
        this.originLeft = this.$refs.beeTableBodyFixHead.getBoundingClientRect().left
        document.getElementById('fixHead').parentElement.style.overflow = 'hidden'
        // 表格高度超过设置高度时设置高度生效
        if(parseFloat(this.height) < this.$refs.bodyDh.clientHeight) {
          this.$refs.bodyDh.style.height = this.height.toString().replace('px', '') + 'px'
          this.widthSmll = true
        } else {
          this.widthSmll = false
        }
        this.$refs.bodyDh.style.overflow = 'auto'
        this.$refs.headDh.style.overflow = 'hidden'
        let timer = setInterval(this.headScroll)
        // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
        this.$once('hook:beforeDestroy', () => {
          clearInterval(timer)
        })
      }
      let tds = this.$refs.colBodyWidth
      if(tds && tds.length) {
        // 自定义表格宽度
        for(let i = 0; i < tds.length; i++) {
          tds[i].style.width = this.width.toString().replace('px', '') + 'px'
          tds[i].style.textAlign = this.align
          // 数据过长是否显示省略号
          if(this.ellipsis) {
            tds[i].style.whiteSpace = 'nowrap'
            tds[i].style.wordBreak = 'keep-all'
            // 有省略号用title显示全部
            if(tds[i].clientWidth - 20 > tds[i].getElementsByTagName('span')[0].clientWidth) {
              tds[i].getElementsByTagName('span')[0].title = ''
            }
          }
        }
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/table/table.vue